import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment.development2';
import { CommonModule } from '@angular/common';

@Component({
  imports: [CommonModule, RouterOutlet],
  selector: 'app-root',
  styleUrls: ['./app.scss'],
  templateUrl: './app.html',
})
export class App {
  title = 'Catena-X Mapping';

  constructor(private titleService: Title) { }

  ngOnInit(): void {
    // Set dynamic title based on environment
    const envSuffix = environment.stage && environment.stage != 'prod' ? ` (${environment.stage.toUpperCase()})` : '';
    this.titleService.setTitle(`${this.title}${envSuffix}`);
  }
}
